import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "input-group-btn" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "checkbox-wrapper" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_12 = { class: "float-end float-start-sm" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Contact", -1 /* HOISTED */);
const _hoisted_15 = { class: "col-xs-12 col-sm-12" };
const _hoisted_16 = { class: "card bg-white data-grid company-detail-grid detached" };
const _hoisted_17 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_19 = { class: "hidden-sm" };
const _hoisted_20 = { class: "hidden-sm" };
const _hoisted_21 = { class: "hidden-sm" };
const _hoisted_22 = { class: "text-center hidden-sm" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { class: "hidden-sm" };
const _hoisted_28 = { class: "hidden-sm" };
const _hoisted_29 = { class: "hidden-sm" };
const _hoisted_30 = { key: 0 };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "5"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_34 = { class: "clearfix" };
const _hoisted_35 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tFirst Name *\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_37 = { class: "invalid-feedback" };
const _hoisted_38 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tLast Name *\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_40 = { class: "invalid-feedback" };
const _hoisted_41 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tPosition\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_43 = { class: "clearfix" };
const _hoisted_44 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tEmail\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_46 = { class: "invalid-feedback" };
const _hoisted_47 = { class: "float-end mt-1" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-envelope-o" }, null, -1 /* HOISTED */);
const _hoisted_49 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tMobile Phone\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_51 = { class: "invalid-feedback" };
const _hoisted_52 = { class: "float-end mt-1" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* HOISTED */);
const _hoisted_54 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tWork Phone\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_56 = { class: "invalid-feedback" };
const _hoisted_57 = { class: "float-end float-start-sm" };
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_input, {
                            type: "text",
                            modelValue: _ctx.query.keywords,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: "Search for...",
                            onKeyup: _withKeys(_ctx.search, ["enter"]),
                            required: ""
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-default",
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.search && _ctx.search(...args)))
                            }, _hoisted_8)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_b_form_checkbox, {
                            id: "includeArchivedContacts",
                            modelValue: _ctx.query.includeDeleted,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.includeDeleted) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [
                                _hoisted_13,
                                _hoisted_14
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ]),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("table", _hoisted_17, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_18,
                                _createTextVNode(),
                                _createElementVNode("th", null, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'FirstName', title: 'Name' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_19, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'Position', title: 'Position' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_20, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'MobilePhone', title: 'Mobile Ph.' }
                                    }, null, 8 /* PROPS */, ["sorter", "column"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_21, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'EmailAddress', title: 'Email' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: _normalizeClass({ 'deleted': item.whenDeleted })
                                }, [
                                    _createElementVNode("td", _hoisted_22, [
                                        _createVNode(_component_b_dropdown, {
                                            variant: "outline-secondary dots",
                                            size: "sm",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.edit(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_23,
                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_divider),
                                                _createTextVNode(),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.archive(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_24,
                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                    [_vShow, !item.whenDeleted]
                                                ]),
                                                _createTextVNode(),
                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                    onClick: ($event) => (_ctx.restore(item))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_25,
                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                    [_vShow, item.whenDeleted]
                                                ])
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                            class: "blue pointer",
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 9 /* TEXT, PROPS */, _hoisted_26)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_27, _toDisplayString(item.position), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_28, _toDisplayString(item.mobilePhone || item.workPhone), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(item.emailAddress), 1 /* TEXT */)
                                ], 2 /* CLASS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, _hoisted_32))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_b_pagination, {
                        class: "float-end",
                        modelValue: _ctx.query.pageNo,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                        "per-page": _ctx.query.pageSize,
                        "total-rows": _ctx.data.recordCount,
                        "hide-ellipsis": true,
                        disabled: _ctx.working
                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "contact_popup",
            modelValue: _ctx.editingPerson,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.editingPerson) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tContact\r\n\t\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_57, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.save(_ctx.person)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_58,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.archive(_ctx.person)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_59,
                            _createTextVNode(" Archive\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.person.personId && !_ctx.person.whenDeleted]
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.restore(_ctx.person)))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_60,
                            _createTextVNode(" Restore\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.person.personId && _ctx.person.whenDeleted]
                    ]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_61,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.firstNameVal, {
                                    type: "text",
                                    modelValue: _ctx.person.firstName,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.person.firstName) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "firstName",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.firstName },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_37, "\r\n\t\t\t\t\t\t\t* Please enter a first name\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.firstName]
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.lastNameVal, {
                                    type: "text",
                                    modelValue: _ctx.person.lastName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.person.lastName) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "lastName",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.lastName },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_40, "\r\n\t\t\t\t\t\t\t* Please enter a last name\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.lastName]
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_41, [
                                _hoisted_42,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.person.position,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.person.position) = $event)),
                                    modelModifiers: { trim: true },
                                    maxlength: "50"
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.emailVal, {
                                    type: "email",
                                    modelValue: _ctx.person.emailAddress,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.person.emailAddress) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "email",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.email },
                                    maxlength: "255"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_46, "\r\n\t\t\t\t\t\t\t* Please enter a valid email\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.email]
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.testEmail())),
                                        disabled: !_ctx.validEmail
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_48,
                                            _createTextVNode(" Test Email\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.mobilePhoneVal, {
                                    type: "tel",
                                    modelValue: _ctx.person.mobilePhone,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.person.mobilePhone) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "mobilePhone",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.mobilePhone },
                                    maxlength: "50"
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_51, "\r\n\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.mobilePhone]
                                ]),
                                _createTextVNode(),
                                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.testSMS())),
                                        disabled: !_ctx.validMobilePhone
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_53,
                                            _createTextVNode(" Test SMS\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ])), [
                                    [_directive_cloud_only]
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, _mergeProps(_ctx.workPhoneVal, {
                                    type: "tel",
                                    modelValue: _ctx.person.workPhone,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.person.workPhone) = $event)),
                                    modelModifiers: { trim: true },
                                    name: "workPhone",
                                    class: { 'is-invalid': _ctx.errors && _ctx.errors.workPhone },
                                    maxlength: "50",
                                    required: ""
                                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                _createTextVNode(),
                                _withDirectives(_createElementVNode("div", _hoisted_56, "\r\n\t\t\t\t\t\t\t* Please enter a valid phone number\r\n\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                    [_vShow, _ctx.errors && _ctx.errors.workPhone]
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
